import React from 'react';
import classNames from 'classnames';

const SplitLayout = ({children, className}) => {



  return (
    <div className={classNames ('split-layout', className)}>
      {children}
    </div>
  );
}

export default SplitLayout;


// WEBPACK FOOTER //
// ./components/layout-split/index.js